export default [
    {
        id: 1,
        title: 'Postarcheck',
        sections: [
            {
                type: 'jumbo',
                title: 'Postarcheck',
                subtitle: 'Gestione della posta. Veloce, efficiente e semplice.',
                text: 'Un sistema efficace per la digitalizzazione e l\'automazione della posta aziendale. Disponibile in cloud o locale.',
                image: '/assets/jumbo-image-postarcheck.png',
            },
            {
                type: 'features',
                title: 'Caratteristiche principali',
                subtitle: 'Digitalizzazione e automatizzazione della posta aziendale.',
                features: [{
                    title: 'Controllo',
                    text: 'Fornendo un facile accesso ai record pertinenti, aiuta a migliorare la gestione, riduce gli errori di elaborazione e migliorara il processo decisionale dell\'azienda.',
                    image: '/assets/pc-icon-4.png',
                },
                {
                    title: 'Velocitá',
                    text: 'Aumentiamo la produttività e la responsabilità all\'interno dell\'organizzazione. Semplifica il tuo flusso di lavoro e traccia la posta per tutto il ciclo di vita dei documenti.',
                    image: '/assets/pc-icon-3.png',
                },
                {
                    title: 'Accessibilitá',
                    text: 'PostarCheck si sente a proprio agio su ogni singolo dispositivo. La sua soluzione cloud offre pieno accesso alla tua posta, ovunque tu sia.',
                    image: '/assets/pc-icon-2.png',
                },
                {
                    title: 'Valore',
                    text: 'PostarCheck è disponibile per un prezzo molto ragionevole in una varietà di offerte. Ospitato su  cloud, localmente  o anche come dispositivo indipendente.',
                    image: '/assets/pc-icon.png',
                }],
            },
            {
                type: 'offers',
                title: 'Offerte',
                subtitle: 'Scegli l\'offerta che si adatta di piú alle tue esigenze.',
                offers: [
                    {
                        title: 'Postarcheck Basic',
                        subtitle: 'Tutto quello che ti serve per un uso giornaliero.',
                        defaultPeriod: 6,
                        pricing: {
                            3: 18,
                            6: 15,
                            12: 14,
                            24: 12,
                        },
                        features: [
                            '1GB di spazio per l\'archiviazione della posta scansionata',
                            'Registrazione di posta in arrivo e in uscita',
                            'Notifica automatica',
                            'Accesso al documento tramite e-mail',
                            'Fino a 3 utenti',
                            'Fino a 120 invii al mese',
                        ],
                    },
                    {
                        title: 'Postarcheck Plus',
                        subtitle: 'Miglior valore',
                        defaultPeriod: 6,
                        bestValue: true,
                        pricing: {
                            3: 21,
                            6: 20,
                            12: 18,
                            24: 17,
                        },
                        features: [
                            'Funzionalità base di Postarcheck',
                            '2 GB di spazio per la posta scansionata',
                            'Classificazione dei documenti',
                            'Scansione della posta',
                            'Riepiloghi giornalieri',
                            'Notifiche SMS',
                            'Completamento automatico delle aziende (varia in base al paese)',
                        ],
                    },
                    {
                        title: 'Postarcheck Pro',
                        subtitle: 'Per le imprese piú complesse',
                        defaultPeriod: 12,
                        pricing: {
                            3: 25,
                            6: 24,
                            12: 20,
                            24: 18,
                        },
                        features: [
                            '50 GB di spazio per la posta scansionata',
                            'Sistema “Mail WorkFlow” su misura',
                            'Autorizzazione avanzata dei documenti',
                            'Ricerca contenuto posta (OCR)',
                            'Stampa di etichette con codice a barre',
                            'Promemoria',
                            'Esportazioni in Excel',
                            'Numero illimitatio degli invii',
                            'Numero illimitato di utenti',
                        ],
                    },
                ],
            },
        ],


    },
    {
        id: 2,
        title: 'Veterinarcheck',
        sections: [
            {
                type: 'jumbo',
                title: 'Veterinarcheck',
                subtitle: 'Sistema di gestione delle pratiche veterinarie.',
                text: 'Veterinarcheck e’ un software usato per assistere nelle operazioni quotidiane nei centri per la cura degli animali. ',
                image: '/assets/jumbo-image-veterinarcheck.png',
                direction: 'right',
            },
            {
                type: 'offers',
                title: 'Offerte',
                subtitle: 'Scegli l\'offerta che si adatta di piú alle tue esigenze.',
                offers: [
                    {
                        title: 'Veterinarcheck',
                        subtitle: 'Controlla le tue attivitá veterinarie.',
                        defaultPeriod: 12,
                        pricing: {
                            6: 25,
                            12: 22,
                            24: 20,
                        },
                        features: [
                            'Gestione del paziente',
                            'Cartella Clinica Elettronica',
                        ],
                    },
                    {
                        title: 'Veterinarcheck Plus',
                        subtitle: 'Concentrati sulla tua attività primarie.',
                        defaultPeriod: 12,
                        pricing: {
                            6: 35,
                            12: 30,
                            24: 28,
                        },
                        features: [
                            'Carateristiche base',
                            'Sistema di appuntamento online',
                            'Integrazione del barCode Scanner',
                        ],
                    },
                ],
            },
        ],
    },
];
